export const Remote = ({ src, width }) => {
  return `${process.env.NEXT_PUBLIC_CDN}/uploads/${width}/${src}`;
};

export const Blur = (src) => {
  return `${process.env.NEXT_PUBLIC_CDN}/uploads/30/${src}`;
};
